import { StateType } from 'data/types'

const getRaw = (state: StateType) => state.historical.positions

export const getData = (state: StateType) => [...getRaw(state).data.positions]
export const getNext = (state: StateType) => getRaw(state).data.next
export const hasMore = (state: StateType) => getRaw(state).data.next !== ''
export const isFetching = (state: StateType) => getRaw(state).fetching
export const hasError = (state: StateType) => getRaw(state).hasError
